<template>
    <div class="plano_modal" v-if="visible">
        <b-card>
            <label> <h3>Edit Shelf</h3> </label>
            <b-container fluid>
                <b-row>
                    <b-col sm="4"> <label>Fixed:</label> </b-col>
                    <b-col sm="8"> <b-form-checkbox v-model="fixed"></b-form-checkbox> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Label:</label> </b-col>
                    <b-col sm="8"> <b-form-input v-model="labelText"></b-form-input> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Bottom Adhesive:</label> </b-col>
                    <b-col sm="8"> <b-form-checkbox v-model="bottomAdhesive"></b-form-checkbox> </b-col>
                </b-row>
            </b-container>
            <b-button-toolbar>
                <b-button style="margin:5px;" variant="primary" @click="validate();">Ok</b-button>
                <b-button style="margin:5px;" @click="cancel();">Cancel</b-button>
            </b-button-toolbar>
        </b-card>
    </div>
</template>

<script>
let editBoardShelfWidget;
window.editBoardShelf = function editBoardShelf(data, onValidate, onCancel) {
    editBoardShelfWidget.fixed = data.fixed;

    editBoardShelfWidget.height = data.height;
    editBoardShelfWidget.coverHeight = data.coverHeight;
    editBoardShelfWidget.coverY = data.coverY;
    editBoardShelfWidget.labelText = data.labelText;
    editBoardShelfWidget.bottomAdhesive = data.bottomAdhesive;
    editBoardShelfWidget.visible = true;
    editBoardShelfWidget.onValidate = onValidate;
    editBoardShelfWidget.onCancel = onCancel;
};

export default {
    data() {
        return {
            fixed: false,
            labelText: "",
            bottomAdhesive: false,
            visible: false,
            onValidate: undefined,
            onCancel: undefined
        };
    },
    created() {
        editBoardShelfWidget = this;
    },
    methods: {
        validate() {
            this.onValidate({
                fixed: this.fixed,
                labelText: this.labelText,
                bottomAdhesive: this.bottomAdhesive,
                height: this.height,
                coverHeight: this.coverHeight,
                coverY: this.coverY
            });
            this.visible = false;
        },
        cancel() {
            this.onCancel();
            this.visible = false;
        }
    }
};
</script>



// WEBPACK FOOTER //
// edit_board_shelf.vue?921dff0a